// Types
import {
  INTENTIONAL_NAVIGATION,
  INTENTIONAL_NAVIGATION_OFF,
  INTENTIONAL_NAVIGATION_ON,
} from '../constants/header-layout.constants';
import {
  HeaderLayoutMethodsHandlersType,
  HeaderLayoutBuilderHandlersType,
} from './types/header-layout.handlers.type';

const backButtonClickHandler = ({
  handleTrackClickBack,
  onHeaderBackClick,
  setShowDropModal,
  setOnHeaderBackClick,
}: HeaderLayoutBuilderHandlersType): void => {
  handleTrackClickBack();
  onHeaderBackClick ? onHeaderBackClick() : setShowDropModal(true);
  setOnHeaderBackClick(null);
};

const closeDropModalActionClickHandler = ({
  setShowDropModal,
}: HeaderLayoutBuilderHandlersType): void => {
  setShowDropModal(false);
};

const beforeUnload = (event: BeforeUnloadEvent): void => {
  if (
    !localStorage.getItem(INTENTIONAL_NAVIGATION) ||
    localStorage.getItem(INTENTIONAL_NAVIGATION) !== INTENTIONAL_NAVIGATION_ON
  ) {
    localStorage.setItem(INTENTIONAL_NAVIGATION, INTENTIONAL_NAVIGATION_OFF);

    // Prevent navigation by pushing the current state back into the history stack
    window.history.pushState(null, '', window.location.href);

    event.preventDefault();
    event.returnValue = ''; // Required to block navigation
  }
};

const popState = (): void => {
  window.history.pushState(null, '', window.location.href);
};

const HeaderLayoutHandlers = (
  props: HeaderLayoutBuilderHandlersType
): HeaderLayoutMethodsHandlersType => ({
  handleCloseDropModalActionClick: () => closeDropModalActionClickHandler(props),
  handleBackButtonClick: () => backButtonClickHandler(props),
  handleBeforeUnload: (event: BeforeUnloadEvent) => beforeUnload(event),
  handlePopState: () => popState(),
});

export { HeaderLayoutHandlers };
